<style>
  .ivu-modal-footer{border: none;}
  .ivu-select-multiple{height: 32px;}
  .ivu-select-selection{z-index:100;}
</style>
<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="toptab">
      <div class="toptableft">
        <span :class="tapidnex==0?'activetap':'nomaltap'" @click="tabclick(0)">不动产联办过户</span>
        <span :class="tapidnex==1?'activetap':'nomaltap'"  @click="tabclick(1)">企业报装</span>
      </div>
    </div>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="单号" prop="orderNO">
                <Input
                  v-model="query.orderNO"
                  clearable
                  placeholder="请输入单号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="申请人姓名" prop="xuserName">
                <Input
                  v-model="query.xuserName"
                  clearable
                  placeholder="请输入申请人姓名"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="申请人身份证" prop="xidCardNO">
                <Input
                  v-model="query.xidCardNO"
                  clearable
                  placeholder="请输入申请人身份证"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="申请人电话" prop="xphoneNO">
                <Input
                  v-model="query.xphoneNO"
                  clearable
                  placeholder="请输入申请人电话"
                />
              </form-item>
            </i-col>
            <i-col span="6" v-show="showopen">
              <form-item label="业务名称" prop="bizType">
                <Select v-model="query.bizType" clearable>
                  <Option
                    v-for="item in bizTypelist"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
           <!-- <i-col span="6" v-show="showopen">
              <form-item label="公司名称" prop="company">
                <Input
                  v-model="query.company"
                  clearable
                  placeholder="请输入公司名称"
                />
              </form-item>
            </i-col> -->
            <i-col span="6" v-show="showopen">
              <form-item label="用户编号" prop="customerId">
                <Input
                  v-model="query.customerId"
                  clearable
                  placeholder="请输入用户编号"
                />
              </form-item>
            </i-col>
            <i-col span="6" v-show="showopen">
              <form-item label="不动产单元号" prop="estateUnitNO">
                <Input
                  v-model="query.estateUnitNO"
                  clearable
                  placeholder="请输入不动产单元号"
                />
              </form-item>
            </i-col>
            <i-col span="6" v-show="showopen">
              <form-item label="原户主姓名" prop="yuserName">
                <Input
                  v-model="query.yuserName"
                  clearable
                  placeholder="请输入原户主姓名"
                />
              </form-item>
            </i-col>
            <i-col span="6" v-show="showopen">
              <form-item label="原户主身份证" prop="yidCardNO">
                <Input
                  v-model="query.yidCardNO"
                  clearable
                  placeholder="请输入原户主身份证"
                />
              </form-item>
            </i-col>
            <i-col span="6" v-show="showopen">
              <form-item label="上报时间" prop="createTime">
                <DatePicker
                  v-model="time"
                  class="time"
                  type="daterange"
                  placeholder="请选择时间"
                ></DatePicker>
              </form-item>
            </i-col>
            <i-col span="6" v-show="showopen">
              <form-item label="办件状态" prop="handlingStatus">
                <Select v-model="query.handlingStatus" clearable>
                  <Option
                    v-for="item in useList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>

          </row>
        </i-form>
        <div class="opens" v-show="!showopen" @click="open"><span>展开</span><span class="openicon iconfont icon--icon_arrow_up"></span></div>
        <div class="opens" v-show="showopen" @click="open"><span>收起</span><span class="iconfont icon--icon_arrow_up"></span></div>
      </div>
      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader"
            :border="true"
            :loading="isLoading"
            :data="tableData"
            stripe
            ref="table"
            height="500"
            @on-selection-change="handleSelect"
          >
            <template slot-scope="{ row, index }" slot="action">
              <span @click="handleClickDetail(row, 'detail')" class="action">[详情]</span>
              <!-- <span @click="handleClickDetail(row, 'do')" class="action">[办理]</span> -->
             <!-- <Poptip
                transfer
                confirm
                title="确认删除?"
                placement="left"
                @on-ok="handleClickDetail(row, 'del')"
              >
                <span class="action">[删除]</span>
              </Poptip> -->
              <!-- <span class="action" @click="handleClickDetail(row, 'audit')">[审核]</span> -->
            </template>

          </i-table>
        </div>

        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            :page-size="pageSize"
            :page-size-opts="pagesizeopts"
            @on-change="pageChange"
            show-total
            show-sizer
            @on-page-size-change="onpagesizechange"
          />
        </div>
      </div>
    </div>

    <Modal v-model="delmodel" width="360">
        <p slot="header" style="color:#f60;text-align:center">
            <Icon type="ios-information-circle"></Icon>
            <span>删除确认</span>
        </p>
        <div style="text-align:center">
            <p>是否确认删除所勾选数据信息？</p>
        </div>
        <div slot="footer">
            <Button type="info" @click="hidedelmodel">取消</Button>
            <Button type="success"  @click="handlealldel">删除</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const {
  getwaterlist,
  getwaterdetail,
  getwaterdelete,
  getwatersenddata,
  getwaterexport
} = api;
const TYPEMAP = {
  0: {handlingStatus: "未接办"},
  1: {handlingStatus: "办理中"},
  2: {handlingStatus: "办理成功"},
  3: {handlingStatus: "办理失败"},
};
export default {
  name: "waterelectricity",
  components: {
    pageHead,
  },

  data() {
    return {
      tapidnex:0,
      delmodel:false,
      showopen:false,
      bizTypelist: [
        {index:"01",type: "供电"},
        {index:"02",type: "燃气"},
        {index:"03",type: "供水"},
        {index:"04",type: "供暖"},
        {index:"05",type: "有线电视"},
        {index:"06",type: "宽带"},
        {index:"07",type: "固话"},
      ],
      useList: [
        {index: 0,type: "未接办"},
        // {index: 1,type: "办理中"},
        {index: 2,type: "办理成功"},
        {index: 3,type: "办理失败"},
      ],
      time:"",
      query: {
        "orderNO": "",
        "xuserName": "",
        "xidCardNO":"",
        "xphoneNO":"",
        "communityId": '',
        "bizType": "",
        "company":"",
        "customerId":"",
        "estateUnitNO": "",
        "yuserName":"",
        "yidCardNO":"",
        "beginTime":"",
        "endTime":"",
        "handlingStatus":'',

      },
      isLoading: false,
      isBtbLoading: false,
      pageNum: 1,
      pageSize: 10,
      pagesizeopts:[10,20,50,100],
      total: 0,
      title: "水电气暖网有线电视固话过户",
      btnList: [
        {name: "搜索",type: "search"},
        {name: "重置",type: "refsh"},
        // {name: "批量删除",type: "del"},
        {name: "导出",type: "export"},
      ],
      tableHeader: [
          {type: "selection",width:70,align: "center",fixed: 'left'},
          {title: "单号",key: "orderNO",width: 190,fixed: 'left',align: "center"},
          {title: "申请人姓名",key: "xuserName",width:140,align: "center"},
          {title: "申请人身份证",key: "xidCardNO",width: 190,align: "center"},
          {title: "申请人电话",key: "xphoneNO",width: 140,align: "center"},
          {title: "业务名称",key: "bizname",width:100,align: "center"},
          {title: "公司名称",key: "company",width:210,align: "center"},
          {title: "用户编号",key: "customerId",width:180,align: "center"},
          {title: "不动产单元号",key: "estateUnitNO",width:180,align: "center"},
          {title: "坐落",key: "address",width:260,align: "center"},
          {title: "原户主姓名",key: "yuserName",width: 140,align: "center"},
          {title: "原户主身份证",key: "yidCardNO",width: 190,align: "center"},
          {title: "上报时间",key: "createTime",width: 180,align: "center"},
          {title: "办件状态",key: "handlingStatus",width: 100,align: "center"},
          {title: "操作",slot: "action",width:140,fixed:"right",align: "center"},
      ],
      tableData: [],
      selectedList:[],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    tabclick(index){
      if(index==1){
        this.tapidnex=index
        this.$router.replace({
          name: "waterelectricitys",
        });
      }
    },
    hidedelmodel(){
      this.delmodel=!this.delmodel
    },
    open(){
      this.showopen=!this.showopen
    },
    onpagesizechange(e){
      this.pageSize=e
      this.pageNum = 1;
      this.getinfo()
    },

    handleBtn(type) {
      if (type == "search") {
        this.pageNum = 1;
        this.getinfo()
      }
      else if (type == "refsh"){
        this.time = "";
        this.pageNum = 1;
          this.query = {
            "orderNO": "",
            "xuserName": "",
            "xidCardNO":"",
            "xphoneNO":"",
            "bizType": "",
            "company":"",
            "customerId":"",
            "estateUnitNO": "",
            "yuserName":"",
            "yidCardNO":"",
            "beginTime":"",
            "endTime":"",
            "handlingStatus":''
          }
          this.getinfo()
      }
      else if (type == "del") {//批量删除
         if(this.selectedList.length==0){
           this.$Message.info("请至少选择一项数据");
           return;
         }else{
           this.delmodel=true
         }
      }else if (type == "export") {//导出
        this.doexport()
      }
    },
    doexport(){
      let url=getwaterexport
      if (this.time[0]) {
        this.query.beginTime = this.$util.FormatDate(
          new Date(this.time[0]),
          "yyyy-MM-dd"
        );
        this.query.endTime = this.$util.FormatDate(
          new Date(this.time[1]),
          "yyyy-MM-dd"
        );
      }
      if(this.query.xidCardNO.length>18){
        this.query.xidCardNO=this.query.xidCardNO.slice(0,18)
      }
      if(this.query.yidCardNO.length>18){
        this.query.yidCardNO=this.query.yidCardNO.slice(0,18)
      }
      let newquerys=this.query
      url=url+"?beginTime="+newquerys.beginTime
        +"&endTime="+newquerys.endTime
        +"&orderNO="+newquerys.orderNO
        +"&xuserName="+newquerys.xuserName
        +"&xidCardNO="+newquerys.xidCardNO
        +"&xphoneNO="+newquerys.xphoneNO
        +"&bizType="+newquerys.bizType
        +"&customerId="+newquerys.customerId
        +"&estateUnitNO="+newquerys.estateUnitNO
        +"&yidCardNO="+newquerys.yidCardNO
        +"&yuserName="+newquerys.yuserName
        +"&handlingStatus="+newquerys.handlingStatus
        +"&token="+ window.sessionStorage.getItem("token")
        window.open(url)
    },
    handleSelect(selection) {
      this.selectedList = [];
      console.log(selection);
      selection.forEach((item) => {
        this.selectedList.push(item.id);
      });
      console.log(this.selectedList);
    },
    handleClickDetail(item, type) {
      console.log(item, type);
      if (type == "detail") {
        localStorage.setItem("querydata",JSON.stringify(this.query))
        this.$router.push({
          name: "waterelectricitydetail",
          query: {orderNO:item.orderNO,id:item.id}
        });
      } else if (type == "del") {
        this.handledel(item.id)
      }else if(type == "do"){

      }
    },
    async handlealldel(){
      if(this.selectedList.length==0){
        this.$Message.info("请至少选择一项数据");
        return;
      }else{
        let url=getwaterdelete+"?idList="+this.selectedList
        let res = await this.$delete(url);
        if (res.isSucceed) {
          this.delmodel=false
          this.$Message.success("删除成功");
          this.getinfo()
        }
      }
    },
    async handledel(id){
      let url=getwaterdelete+"?idList="+[id]
      let res = await this.$delete(url);
      if (res.isSucceed) {
        this.$Message.success("删除成功");
        this.getinfo()
      }
    },
    pageChange(val) {
      this.pageNum = val;
      this.getinfo()
    },
    async getinfo(){
      this.isLoading = true;
      this.query.communityId = this.$store.state.streetorcommunityid
      try {
        if (this.time[0]) {
          this.query.beginTime = this.$util.FormatDate(
            new Date(this.time[0]),
            "yyyy-MM-dd"
          );
          this.query.endTime = this.$util.FormatDate(
            new Date(this.time[1]),
            "yyyy-MM-dd"
          );
        }
        if(this.query.xidCardNO.length>18){
          this.query.xidCardNO=this.query.xidCardNO.slice(0,18)
        }
        if(this.query.yidCardNO.length>18){
          this.query.yidCardNO=this.query.yidCardNO.slice(0,18)
        }
        console.log(this.$store.state.streetorcommunityid)
        let res = await this.$post(getwaterlist, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.query,
        });
        let list = res.rows.map((item) => ({
          ...item,
          bizname:item.bizType=="01"?"供电":item.bizType=="02"?"燃气":item.bizType=="03"?"供水":item.bizType=="04"?"供暖":item.bizType=="05"?"有线电视":item.bizType=="06"?"宽带":item.bizType=="07"?"固话":"",

          ...TYPEMAP[item.handlingStatus != null ? +item.handlingStatus : null],
        }));
        console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    }
  },

  created() {
    this.getinfo()
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin:0 20px 20px 20px;
}
.toptab{display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;margin-top: -30px;height: 30px;display: flex;display: -webkit-flex;align-items: center;position: relative;z-index: 2;}
.toptableft{display: flex;display: -webkit-flex;margin-left:20px;}
.toptableft span{width: auto;height: 32px;text-align: center;line-height: 32px;font-size: 16px;padding:0 5px}
.toptableft span:nth-child(4){width: 136px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
.bottombtn{width:150px;text-align: center;height:32px;line-height:32px;font-size: 16px;color: #FFFFFF;border-radius: 6px;background: #0097FF;}
.activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
.nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.search {width: 100%;background-color: white;border-radius: 5px;padding: 20px;margin-bottom: 20px;}
.label {width: 100px;}
.time {width: 100%;}
.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  // padding: 20px;
  min-height: calc(100vh - 550px);
  .page {width: 100%;padding-bottom:20px;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}
.opens{margin: 0 auto;height:30px;width: 100px;display: flex;justify-content: center;align-items: center;}
.opens span:nth-child(2){margin-left: 40px;color: #666666;}
.openicon{transform: rotate(180deg);}

</style>
